import { useLocation } from "react-router-dom";
import { useState, useEffect } from "react";
import axios from "axios";
import searchIcon from "/assets/icon/Search.svg";
import editIcon from "/assets/icon/Edit.png";
import True from "/assets/T.png";
import False from "/assets/F.png";
import "./styles/LightSwitch.css";
import AddPoleModal from "../../components/addPoleForm";
import UserStatus from "../../components/UserStatus";
import EditPoleModal from "../../components/EditPoleModal";
import Delete from "/assets/icon/delete.png";
import img1 from "/1.png";
import img2 from "/2.png";

function PoleDetail() {
  const location = useLocation();
  const {
    poleId,
    mainPoleName,
    mainPoleCode,
    mainPoleLocation,
    mainPoleLat,
    mainPoleLng,
    mainPoleActive,
    mainSecondaryPoleCount,
    installationDate,
    firmwareVersion,
    deviceCode,
    hasScreen,
    screenId,
    screenModel,
    screenInstall,
    screenActive,
    branchName,
    cameras,
    schedule_light_bulbs,
    schedule_light_bulbs_rule,
    custom_schedule_light_bulbs_active,
  } = location.state || {};

  const [subordinatePoles, setSubordinatePoles] = useState([]);
  const [isAddPoleVisible, setIsAddPoleVisible] = useState(false);
  const [isEditModalVisible, setIsEditModalVisible] = useState(false);
  const [editingPole, setEditingPole] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredSubordinatePoles, setFilteredSubordinatePoles] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const postsPerPage = 6;

  const indexOfLastPost = currentPage * postsPerPage;
  const indexOfFirstPost = indexOfLastPost - postsPerPage;
  const currentPoles = filteredSubordinatePoles.slice(
    indexOfFirstPost,
    indexOfLastPost
  );

  const fetchSubordinatePoles = () => {
    if (poleId) {
      axios
        .get(`${import.meta.env.VITE_API_URL}/poles/${poleId}/subordinates`)
        .then((response) => {
          setSubordinatePoles(response.data);
        })
        .catch((error) => {
          if (error.response && error.response.status === 404) {
            console.log(error.response.data.message);
          } else {
            console.error("Error fetching subordinate poles:", error);
          }
        });
    }
  };

  useEffect(() => {
    fetchSubordinatePoles();
  }, [poleId]);

  useEffect(() => {
    setFilteredSubordinatePoles(
      subordinatePoles.filter(
        (pole) =>
          pole.code.toLowerCase().includes(searchTerm.toLowerCase()) ||
          pole.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
          pole.location.toLowerCase().includes(searchTerm.toLowerCase())
      )
    );
  }, [subordinatePoles, searchTerm]);

  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
  };

  const handleEditPole = (pole) => {
    const editedPole = {
      poleId: pole.id,
      mainPoleName: pole.name, // Use pole.name instead of mainPoleName
      mainPoleCode: pole.code,
      mainPoleLocation: pole.location,
      mainPoleLat: pole.lat,
      mainPoleLng: pole.lng,
      mainPoleActive: pole.active,
      mainSecondaryPoleCount: null,
      installationDate: pole.installation_date,
      firmwareVersion: pole.firmware_version,
      deviceCode: pole.hardware_id,
      hasScreen: pole.has_screen,
      screenId: pole.screen_id,
      screenModel: pole.screen_model,
      screenInstall: pole.screen_installation_date,
      screenActive: null,
      branchName: branchName,
      cameras: pole.cameras,
      schedule_light_bulbs: pole.schedules,
      schedule_light_bulbs_rule: pole.schedule_light_bulbs_rule,
      custom_schedule_light_bulbs_active:
        pole.custom_schedule_light_bulbs_active,
      poleType: "sub",
      master_name: pole.master_name,
    };

    setEditingPole(editedPole);
    setIsEditModalVisible(true);
  };

  const handleEditMainPole = () => {
    const mainPole = {
      poleId,
      mainPoleName,
      mainPoleCode,
      mainPoleLocation,
      mainPoleLat,
      mainPoleLng,
      mainPoleActive,
      mainSecondaryPoleCount,
      installationDate,
      firmwareVersion,
      deviceCode,
      hasScreen,
      screenId,
      screenModel,
      screenInstall,
      screenActive,
      branchName,
      cameras,
      schedule_light_bulbs,
      schedule_light_bulbs_rule,
      custom_schedule_light_bulbs_active,
      poleType: "main",
    };

    setEditingPole(mainPole);
    setIsEditModalVisible(true);
  };

  return (
    <div className="containerPage">
      <br />
      <br />
      <h1 className="userManagement">การจัดการเสาไฟ</h1>

      <div className="mainPoleName">
        <div className="top1">
          <div className="pole-infoDetail">
            <div className="pole-info-title">
              <div className="statuslight1">
                <label className="labePole">เสาหลัก</label>
                <div className="statuslight">
                  <UserStatus isOnline={mainPoleActive} />
                </div>
              </div>
              <p className="up">รหัสเสาหลัก</p>
              <h1 className="up">{mainPoleCode}</h1>
            </div>
            <div className="polestaus2">
              <label className="labePole">เสารอง</label>
              <p>มีเสารองทั้งหมด</p>
              <h1>{mainSecondaryPoleCount}</h1>
            </div>
            <div className="polestaus3">
              <p>สาขา {mainPoleName || "###"}</p>
              <p>
                <img src={img1} alt="Location icon" />
                {mainPoleLocation}
              </p>
              <p>
                <img src={img2} alt="Coordinates icon" />
                {mainPoleLat}, {mainPoleLng}
              </p>
            </div>
            <img
              src={editIcon}
              alt="Editicon"
              className="arrowr"
              onClick={handleEditMainPole}
            />
            <img src={Delete} className="arrowrDelete" alt="Delete icon" />
          </div>
        </div>
      </div>
      <div className="sectionAddButton">
        <div className="search-bar">
          <img src={searchIcon} alt="Search" />
          <input
            type="text"
            placeholder="ค้นหารหัสเสา ชื่อเสา ตำแหน่งติดตั้ง"
            value={searchTerm}
            onChange={handleSearchChange}
          />
        </div>
      </div>
      {isAddPoleVisible && (
        <AddPoleModal onClose={() => setIsAddPoleVisible(false)} />
      )}
      <div className="detailAllPole">
        <div>
          ข้อมูลเสารอง{" "}
          <span className="allBranches"> {subordinatePoles.length}</span> เสา
        </div>

        {currentPoles.length > 0 ? (
          <table className="pole-table">
            <thead>
              <tr>
                <th>แก้ไข</th>
                <th>รหัสเสา</th>
                <th>ชื่อเสา</th>
                <th>สถานที่ติดตั้ง</th>
                <th>พิกัด</th>
                <th>ไฟแบบอัตโนมัติ</th>
                <th>สถานะเสา</th>
              </tr>
            </thead>
            <tbody>
              {currentPoles.map((pole, index) => (
                <tr key={index}>
                  <td>
                    <div className="flexImg">
                      <img
                        src={editIcon}
                        alt="Edit"
                        onClick={() => handleEditPole(pole)}
                      />
                      <img
                        src={Delete}
                        className="arrowrDelete2"
                        alt="Delete icon"
                      />
                    </div>
                  </td>
                  <td>{pole.code}</td>
                  <td>{pole.name}</td>
                  <td>{pole.location}</td>
                  <td>{`${pole.lat}, ${pole.lng}`}</td>
                  <td>
                    <img
                      src={
                        pole.custom_schedule_light_bulbs_active ? True : False
                      }
                      alt={
                        pole.custom_schedule_light_bulbs_active
                          ? "กำหนดเอง"
                          : "ค่าเริ่มต้น"
                      }
                    />
                    &nbsp;&nbsp;&nbsp;
                    {pole.schedule_light_bulbs_rule === 1
                      ? "ค่าเริ่มต้น"
                      : "กำหนดเอง"}
                  </td>
                  <td className="w200">
                    <div className="w150">
                      <UserStatus isOnline={pole.active} />
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <p>ไม่มีข้อมูลเสารองที่มีอยู่</p>
        )}
        {subordinatePoles.length > postsPerPage && (
          <div className="pagination">
            <button
              onClick={() => setCurrentPage(currentPage - 1)}
              disabled={currentPage === 1}
            >
              &laquo;
            </button>
            {Array.from(
              { length: Math.ceil(subordinatePoles.length / postsPerPage) },
              (_, index) => (
                <button
                  key={index}
                  onClick={() => setCurrentPage(index + 1)}
                  className={currentPage === index + 1 ? "active" : ""}
                >
                  {index + 1}
                </button>
              )
            )}
            <button
              onClick={() => setCurrentPage(currentPage + 1)}
              disabled={currentPoles.length < postsPerPage}
            >
              &raquo;
            </button>
          </div>
        )}
      </div>
      {isEditModalVisible && (
        <EditPoleModal
          pole={editingPole}
          fetchSubordinatePoles={fetchSubordinatePoles}
          onClose={() => {
            setIsEditModalVisible(false);
            setEditingPole(null);
          }}
        />
      )}
    </div>
  );
}

export default PoleDetail;
